import classNames from 'classnames';
import PropTypes from 'prop-types';

// ---------------------------------------------------------

import { copyToClipboard } from '@lib/utils.js';

// ---------------------------------------------------------

import Button from '@components/button';
import Modal from '../index.js';

// ---------------------------------------------------------

import styles from './styles.module.scss';
const {
  container,
  copy_url_button,
  copy_url_container,
  copy_url_display,
  share_button,
  share_buttons_container,
  share_button_facebook,
  share_button_linkedin,
  share_button_x,
  share_button_email
} = styles;

const share_button_theme = {
  Email: share_button_email,
  Facebook: share_button_facebook,
  LinkedIn: share_button_linkedin,
  X: share_button_x
};

const ShareModal = (props) => {
  const { copyUrl, sharingServicesCollection } = props;
  const copyUrlToClipboard = () => {
    copyToClipboard(copyUrl);
  };

  const getSharingServices = () => {
    let sharingServices = sharingServicesCollection || [];
    const xButton = sharingServices.find((service) => service.shareName === 'X');
    return sharingServices.filter((service) => service.shareName !== 'X').concat(xButton);
  };

  const shareModalContent = (
    <div className={container}>
      <h2>Share!</h2>
      <p>Email or share link via social media</p>
      <div className={copy_url_container}>
        <span className={copy_url_display}>{copyUrl}</span>
        <span className={copy_url_button}>
          <Button
            className={copy_url_button}
            theme="black"
            label="Copy Link"
            onClick={copyUrlToClipboard}
          />
        </span>
      </div>
      {sharingServicesCollection && (
        <div className={share_buttons_container}>
          {(getSharingServices() || []).map(({ shareName, shareUrl }) => {
            const buttonClasses = classNames(share_button, {
              [share_button_theme[shareName]]: share_button_theme[shareName]
            });
            return (
              <Button
                icon={shareName.toLowerCase()}
                iconType={shareName === 'Email' ? 'actions' : 'social'}
                key={shareUrl}
                label={shareName === 'X' ? null : shareName}
                url={shareUrl}
                theme="red"
                className={buttonClasses}
              />
            );
          })}
        </div>
      )}
    </div>
  );

  return <Modal {...props} content={shareModalContent} />;
};

ShareModal.propTypes = {
  /**
   * Canonical Url to be displayed and copied onto the clipboard
   */
  copyUrl: PropTypes.string,

  /**
   * Collection of share items to be displayed within the modal
   */
  sharingServicesCollection: PropTypes.arrayOf(
    PropTypes.shape({
      shareName: PropTypes.string,
      shareUrl: PropTypes.string
    })
  )
};

export default ShareModal;
